import {makeAutoObservable} from 'mobx';
import {getStore, useStore} from "./index";
import studioPlugin from "../editor/plugins/global/studioPlugin";
import pluginWeb from "../editor/plugins/web";

export class PluginStore {
    store;

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    getPluginsToLoad() {
        return [
            pluginWeb,
            studioPlugin
        ];
    }
}


export const usePluginStore = () => {
    return useStore().pluginStore;
}

export const getPluginStore = () => {
    return getStore().pluginStore;
}